import styled from 'styled-components';

const TextTruncated = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export default TextTruncated;
